import React from "react";
import { Box } from "@material-ui/core";
import { OrderListTable } from "../../table";
import { GeneralSearch } from "components/search";
import ExportExcelSelect from "modules/warrantee/components/select/exportExcelSelect";

export default function GiftListPanelComponent({
  hasGiftRedemptionEditAccessRight,
  data,
  isFetching,
  page,
  search,
  rowsPerPage,
  totalRecords,
  handleChangePage,
  handleChangeRowsPerPage,
  handleSearch,
  handleCreate,
  handleStatusChange,
  handleReload,
  paginationOptions,
  handleExport,
  isExporting
}) {
  const exportDropdown = [
    { name: "CSV", value: "csv" }
  ];

  return (
    <Box >
      <GeneralSearch
        handleFilter={(value) => {
          handleSearch(value);
        }}
        isFetching={isFetching}
      />

      <Box
        style={{
          display: "flex",
          justifyContent: "space-between",
          paddingBottom: "12px",
        }}
      >
        <Box style={{ display: "flex" }}>
        </Box>
        <ExportExcelSelect
          disabled={isExporting || isFetching || data.length === 0}
          dropdownItem={exportDropdown}
          isLoading={isExporting}
          handleSelection={(type) => handleExport(type)}
        />
      </Box>

      <OrderListTable
        hasGiftRedemptionEditAccessRight={hasGiftRedemptionEditAccessRight}
        data={data}
        isFetching={isFetching}
        page={page}
        search={search}
        rowsPerPage={rowsPerPage}
        totalRecords={totalRecords}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        handleCreate={handleCreate}
        handleStatusChange={handleStatusChange}
        handleReload={handleReload}
        paginationOptions={paginationOptions}
      />
    </Box>
  );
}
